import { zodResolver } from "@hookform/resolvers/zod";
import type { FieldValues, Resolver } from "react-hook-form";
import type { z } from "zod";

// Types the resolver on the schema output, which is what forms declare `useForm<Values>` with.
// Under zod 4 the input of z.coerce/z.preprocess is `unknown` and .default() fields are optional,
// so the input type @hookform/resolvers 5 infers no longer matches those form values.
export const zodFormResolver = <T extends FieldValues>(schema: z.ZodType<T, FieldValues>): Resolver<T> =>
  zodResolver(schema) as unknown as Resolver<T>;
